const OAUTH2_REDIRECT_URL = "Test Constant";

export default {
    OAUTH2_REDIRECT_URL
};